__turbopack_context__.v({
  "clearButton": "style-module-scss-module__A20MCq__clearButton",
  "historyActions": "style-module-scss-module__A20MCq__historyActions",
  "iconButton": "style-module-scss-module__A20MCq__iconButton",
  "note": "style-module-scss-module__A20MCq__note",
  "notes": "style-module-scss-module__A20MCq__notes",
  "queryActions": "style-module-scss-module__A20MCq__queryActions",
  "queryBox": "style-module-scss-module__A20MCq__queryBox",
  "root": "style-module-scss-module__A20MCq__root",
  "section": "style-module-scss-module__A20MCq__section",
  "sectionHeader": "style-module-scss-module__A20MCq__sectionHeader",
  "sectionHeaderActions": "style-module-scss-module__A20MCq__sectionHeaderActions",
  "sectionIcon": "style-module-scss-module__A20MCq__sectionIcon",
  "sectionItems": "style-module-scss-module__A20MCq__sectionItems",
  "sectionRow": "style-module-scss-module__A20MCq__sectionRow",
  "sectionRowCaption": "style-module-scss-module__A20MCq__sectionRowCaption",
  "sectionRowIcon": "style-module-scss-module__A20MCq__sectionRowIcon",
  "sectionRowLabel": "style-module-scss-module__A20MCq__sectionRowLabel",
  "sectionRows": "style-module-scss-module__A20MCq__sectionRows",
  "sectionTitle": "style-module-scss-module__A20MCq__sectionTitle",
  "submitButton": "style-module-scss-module__A20MCq__submitButton",
  "tokenRow": "style-module-scss-module__A20MCq__tokenRow",
  "tokenShimmer": "style-module-scss-module__A20MCq__tokenShimmer",
  "tokens": "style-module-scss-module__A20MCq__tokens",
  "unparsed": "style-module-scss-module__A20MCq__unparsed",
  "unparsedText": "style-module-scss-module__A20MCq__unparsedText",
});
